/* beautiful-react-hooks version: 0.35.0 */
import { slicedToArray as _slicedToArray } from './_virtual/_rollupPluginBabelHelpers.js';
import { useState } from 'react';
import useDragEvents from './useDragEvents.js';

var useDropZone = function useDropZone(targetRef) {
  var _useDragEvents = useDragEvents(targetRef, false),
      onDrop = _useDragEvents.onDrop,
      onDragOver = _useDragEvents.onDragOver,
      onDragLeave = _useDragEvents.onDragLeave;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOver = _useState2[0],
      setIsOver = _useState2[1];

  onDragOver(function (event) {
    event.preventDefault();
    setIsOver(true);
  });
  onDragLeave(function () {
    setIsOver(false);
  });
  return {
    isOver: isOver,
    onDrop: onDrop
  };
};

export default useDropZone;
